 $(document).ready(function(){

	/*********************************
	************ NAVBAR **************
	*********************************/
	 $(".button-collapse").sideNav({
	 	draggable: false,
	 	closeOnClick: true,
	 });


	/*********************************
	********** SCROLL MENU ***********
	*********************************/
	$(document).on("scroll", onScroll);
	
	//smoothscroll
	$('a[href^="#"]').on('click', function (e) {
		e.preventDefault();
		$(document).off("scroll");
		
		$('a').each(function () {
			$(this).removeClass('menu-active');
		})
		$(this).addClass('menu-active');
	
		var target = this.hash,
		menu = target;
		$target = $(target);
		$('html, body').stop().animate({
			'scrollTop': $target.offset().top
		}, 500, 'swing', function () {
			window.location.hash = target;
			$(document).on("scroll", onScroll);
		});
	});

	function onScroll(event){
		var scrollPos = $(document).scrollTop();
		$('#nav-menu-top a').each(function () {
			var currLink = $(this);
			var refElement = $(currLink.attr("href"));
			if (refElement.position().top <= scrollPos && refElement.position().top + refElement.height() > scrollPos) {
				$('#nav-menu-top ul li a').removeClass("menu-active");
				currLink.addClass("menu-active");
			}
			else{
				currLink.removeClass("menu-active");
			}
		});
	}



	/*********************************
	************ ISOTOPE *************
	*********************************/

	var $grid = $('#projet-wrapper-row').isotope({
		itemSelector: '.projet-item',
		getSortData: {
			date: '[data-date]',
			nom: '.projet-name',
			fierte: '.projet-fierte'
		},
		sortBy: 'date',
		sortAscending: {
			date: false,
			nom: true,
			fierte: false
		},
	});

	$('.btn-filtre-wrapper').on( 'click', 'button', function() {
		var filterValue = $(this).attr('data-filtre');
		$grid.isotope({ filter: filterValue });
	});

	$('.btn-tri-wrapper').on( 'click', 'button', function() {
		var sortValue = $(this).attr('data-tri');
		$grid.isotope({ sortBy: sortValue });
	});

	$('.btn-group').each( function( i, buttonGroup ) {
		var $buttonGroup = $( buttonGroup );
		$buttonGroup.on( 'click', 'button', function() {
			$buttonGroup.find('.btn-active').removeClass('btn-active');
		$( this ).addClass('btn-active');
		});
	});

	/***********************************
	************* CONTACTF *************
	***********************************/
	$('[name="your-firstname"]').attr('placeholder', 'Prénom *');
	$('[name="your-name"]').attr('placeholder', 'Nom *');
	$('[name="your-email"]').attr('placeholder', 'Mail *');
	$('[name="your-telephone"]').attr('placeholder', 'Téléphone');
	$('[name="your-subject"]').attr('placeholder', 'Sujet *');
	$('[name="your-message"]').attr('placeholder', 'Message *');


	/**********************************
	*************** REVEAL ************
	**********************************/
	window.sr = ScrollReveal({mobile: false, duration: 800, distance: '80px', scale: '1', viewFactor: 0.5});
	// HOME
	sr.reveal('#page-home h1', {origin: 'top', duration: 1600, viewFactor: 0.8, mobile: true, delay: 1000});
	sr.reveal('#page-home h2', {origin: 'bottom', duration: 1600, viewFactor: 0.8, mobile: true, delay: 1000});
	sr.reveal('#page-home #home-situation', {distance: '0', duration: 1200, viewFactor: 0.8, mobile: true, delay: 3400});
	// PRESENTATION
	sr.reveal('#page-presentation  .presentation-tag', {origin: 'bottom', distance: '20px', duration: 600, viewFactor: 1}, 100);
	sr.reveal('#page-presentation p', {origin: 'left'});
	sr.reveal('#page-presentation #home-philosophie-auteur', {distance: '0'});
	// PARCOURS
	sr.reveal('#page-parcours .experience-pro .experience-item p', {origin: 'left', viewFactor: 1}, 100);
	sr.reveal('#page-parcours .formation .experience-item p', {origin: 'right', viewFactor: 1}, 100);
	sr.reveal('#parcours-cv a', {origin: 'top', distance: '0px', delay: 400});
	// PORTFOLIO 
	sr.reveal('.projet-item .projet-item-wrapper', {distance: '0px', duration: 600, viewFactor: 0.1}, 100);
	sr.reveal('#page-portfolio #projet-isotope #projet-filtre button', {distance: '0px', distance: '20px', duration: 600}, 100);
	sr.reveal('#page-portfolio #projet-isotope #projet-tri button', {distance: '0px', distance: '20px', duration: 600}, 100);
	// CONTACT
	sr.reveal('#contact-form', {origin: 'left',  viewFactor: 0.3});
	sr.reveal('#contact-info-wrapper', {origin: 'right', viewFactor: 0.8});


	/********************************
	************* MODAL *************
	********************************/
	$('.modal').modal();
});	



//////////////////
// WEBPACK FOOTER
// ./assets/js/main.js
// module id = 0
// module chunks = 0